import React from "react";
import { Grid, Typography } from "@mui/material";

type StepLayoutProps = {
  title: string;
  children: React.ReactNode;
}

const StepLayout: React.FC<StepLayoutProps> = ({ title, children }) => (
  <>
    <Grid size={{ xs: 12 }} sx={{ mb: 2 }}>
      <Typography variant="h5">{title}</Typography>
    </Grid>
    {children}
  </>
);

export default StepLayout;


